import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useUser from './useUser';
import { initSettings } from '../containers/settingsSlice';
import { httpGet } from '../../utils';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { useIsCloudOnly } from './featureFlags/useIsCloudOnly';

const useInitSettings = () => {
    const [isLoading, setIsLoading] = useState(true);
    useUser();

    const dispatch = useDispatch();
    const user = useSelector((state) => state.userData.user);
    const sessionTimeout = useSelector((state) => state.userData.sessionTimeout);

    const isCloudOnly = useIsCloudOnly();

    useEffect(() => {
        if (user && sessionTimeout) {
            async function getUserData() {
                const response = await httpGet('/Settings/GetSystemSettings', { [HTTP_OPTIONS.HANDLE_ERRORS]: true });
                if (response.data) {
                    dispatch(initSettings({ ...response.data, user, isCloudOnly }));
                }
                setIsLoading(false);
            }

            getUserData();
        }
    }, [user, sessionTimeout, dispatch]);
    return isLoading;
};

export default useInitSettings;
